export enum DocumentType {
    Docx = 0,
    Xlsx = 1,
    Pptx = 2,
    Idml = 3,
}